// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"39ae5759","842":"674b5883"}[chunkId] + ".chunk.js";
};